/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPlannedServicesForEmployeeAndDateIdDateGet } from '../fn/schedule/get-planned-services-for-employee-and-date-id-date-get';
import { GetPlannedServicesForEmployeeAndDateIdDateGet$Params } from '../fn/schedule/get-planned-services-for-employee-and-date-id-date-get';
import { getSchedulesAppointments$Json } from '../fn/schedule/get-schedules-appointments-json';
import { GetSchedulesAppointments$Json$Params } from '../fn/schedule/get-schedules-appointments-json';
import { getSchedulesAppointments$Plain } from '../fn/schedule/get-schedules-appointments-plain';
import { GetSchedulesAppointments$Plain$Params } from '../fn/schedule/get-schedules-appointments-plain';
import { VScheduledAppointment } from '../models/v-scheduled-appointment';

@Injectable({ providedIn: 'root' })
export class ScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSchedulesAppointments()` */
  static readonly GetSchedulesAppointmentsPath = '/Schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchedulesAppointments$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchedulesAppointments$Plain$Response(params?: GetSchedulesAppointments$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VScheduledAppointment>>> {
    return getSchedulesAppointments$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchedulesAppointments$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchedulesAppointments$Plain(params?: GetSchedulesAppointments$Plain$Params, context?: HttpContext): Observable<Array<VScheduledAppointment>> {
    return this.getSchedulesAppointments$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VScheduledAppointment>>): Array<VScheduledAppointment> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchedulesAppointments$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchedulesAppointments$Json$Response(params?: GetSchedulesAppointments$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VScheduledAppointment>>> {
    return getSchedulesAppointments$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchedulesAppointments$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchedulesAppointments$Json(params?: GetSchedulesAppointments$Json$Params, context?: HttpContext): Observable<Array<VScheduledAppointment>> {
    return this.getSchedulesAppointments$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VScheduledAppointment>>): Array<VScheduledAppointment> => r.body)
    );
  }

  /** Path part for operation `getPlannedServicesForEmployeeAndDateIdDateGet()` */
  static readonly GetPlannedServicesForEmployeeAndDateIdDateGetPath = '/GetPlannedServicesForEmployeeAndDate/{id}/{date}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlannedServicesForEmployeeAndDateIdDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedServicesForEmployeeAndDateIdDateGet$Response(params: GetPlannedServicesForEmployeeAndDateIdDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getPlannedServicesForEmployeeAndDateIdDateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlannedServicesForEmployeeAndDateIdDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedServicesForEmployeeAndDateIdDateGet(params: GetPlannedServicesForEmployeeAndDateIdDateGet$Params, context?: HttpContext): Observable<void> {
    return this.getPlannedServicesForEmployeeAndDateIdDateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
